module.exports = __webpack_public_path__ + "img/30.904695a7.png";